import { observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';

import { StatBox } from '@feathr/components';

import type { IStatProps } from './Stats';

function UniqueClicksStat({
  label = 'Unique Clicks',
  size = 'default',
  tooltip = 'The total number of people who clicked on marketing material.',
  value,
}: IStatProps): JSX.Element {
  const formatted = numeral(value).format('0,0');

  return <StatBox label={label} primary={formatted} size={size} tooltip={tooltip} />;
}

export default observer(UniqueClicksStat);
